// Lightweight registry for custom surface element constructors
// Allows apps to register new element types without editing core maps

// eslint-disable-next-line @typescript-eslint/no-explicit-any
type ElementCtor = new (...args: any[]) => BlockSuite.SurfaceElementModel;

const customElementsCtorMap: Record<string, ElementCtor> = Object.create(null);

export function registerSurfaceElementType(
    type: string,
    ctor: ElementCtor
) {
    customElementsCtorMap[type] = ctor;
}

export function getCustomElementsCtorMap() {
    return customElementsCtorMap;
}


